import React, { useState } from 'react';
import axios from 'axios';
import './FileConversion.css';

const FileConversion = () => {
  const [wordFile, setWordFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setWordFile(file);
  };

  const handleConvertToPdf = async () => {
    if (!wordFile) {
      alert('Please upload a Word file first.');
      return;
    }

    setLoading(true);
    setError('');
    const formData = new FormData();
    formData.append('wordFile', wordFile);

    try {
      const response = await axios.post('http://localhost:8000/api/convert', formData, {
        responseType: 'blob',
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
    } catch (err) {
      setError('Error converting file: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Navbar */}
      <div className="navbar">
        <h1>DocNova</h1>
        <div>
          <a href="https://filetranfer.tech">Home</a>
          <a href="/dashboard">Dashboard</a>
          <a href="/logout">Logout</a>
        </div>
      </div>

      {/* Main Content */}
      <div className="file-conversion-container">
        <h1 className="header">Word to PDF Converter</h1>

        <div className="input-container">
          <input
            type="file"
            accept=".docx"
            onChange={handleFileChange}
            className="file-input"
          />
        </div>

        <button
          onClick={handleConvertToPdf}
          disabled={loading}
          className={`convert-btn ${loading ? 'loading' : ''}`}
        >
          {loading ? <div className="spinner"></div> : 'Convert to PDF'}
        </button>

        {error && <p className="error">{error}</p>}

        {pdfUrl && (
          <div className="success-message">
            <p>Conversion Successful! Download your PDF:</p>
            <a href={pdfUrl} download="converted.pdf" className="download-link">
              Download PDF
            </a>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="footer">
        © {new Date().getFullYear()} DocNova — All rights reserved.
      </div>
    </>
  );
};

export default FileConversion;
